import { styled } from "@mui/material/styles";

// Components
import { Tabs } from "@mui/material";

const styledName = "Categories";

export const StyledTabs = styled(Tabs, { name: styledName })({
  "&": {
    width: "100%",
  },
});
